// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__Lv61-","signatureButtonsRight":"ModalSign_signatureButtonsRight__1F7W7"};